import { OptionItem } from '@shared/components/common-select-control/common-select-control.types';

export enum WidgetMetric {
    Number = 'Number',
    Percentage = 'Percentage',
    Both = 'Both',
}

export type WidgetMetricOption = OptionItem & { metric: WidgetMetric };
